import { render, staticRenderFns } from "./FiflboxNoticeView.vue?vue&type=template&id=38e5e7f8"
import script from "./FiflboxNoticeView.vue?vue&type=script&lang=js"
export * from "./FiflboxNoticeView.vue?vue&type=script&lang=js"
import style0 from "./FiflboxNoticeView.vue?vue&type=style&index=0&id=38e5e7f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports